import { ConversationItemParts, mailStore } from 'owa-mail-store';
import { action } from 'satcheljs/lib/legacy';

export interface SetIsPendingDeleteConversationItemPartsState {
    conversationItemParts: ConversationItemParts;
}

export default action('setIsPendingDeleteConversationItemParts')(
    function setIsPendingDeleteConversationItemParts(
        conversationId: string,
        isPendingDelete: boolean,
        state: SetIsPendingDeleteConversationItemPartsState = {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (16,13): Type 'ConversationItemParts | undefined' is not assignable to type 'ConversationItemParts'.
            // @ts-expect-error
            conversationItemParts: mailStore.conversations.get(conversationId),
        }
    ) {
        const conversationItemParts = state.conversationItemParts;
        if (conversationItemParts) {
            conversationItemParts.isPendingDelete = isPendingDelete;
        }
    }
);
